import { Image } from '@chakra-ui/image';
import React from 'react';

import {
    Logo, Logos, Title, MenuItem, Description
} from '../product-switcher.styled';
import {
    MenuConfigProps, NavigationUrls
} from '../product-switcher.types';
import { useGetMappedConfig } from './use-get-mapped-config';

export const useMenuGenerator = (menuConfig : MenuConfigProps) => {
    const {
        getMappedIcons,
        getMappedConfig,
        getMappedNavigationUrls
    } = useGetMappedConfig();
    const handleMenuClick = (navigationUrlId: NavigationUrls) => {
        const navigationUrl = getMappedNavigationUrls(navigationUrlId);

        window.open(navigationUrl, '_self');
    };

    return (
        menuConfig.map(({
            id,
            icons,
            styles,
            navigationUrlId
        }) => {
            const {
                title, description
            } = getMappedConfig(id);

            return (
                <MenuItem key={title} {...styles} onClick={() => handleMenuClick(navigationUrlId)}>
                    <Logos>
                        {
                            icons.map(icon => <Logo key={icon}><Image src={getMappedIcons(icon)} h={'42px'} /></Logo>)
                        }
                    </Logos>
                    <Title>{title}</Title>
                    <Description>{description}</Description>
                </MenuItem>
            );
        }
        )
    );
};
